module.exports = __webpack_public_path__ + "static/media/pa.62144a17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/pa.png
// module id = 1951
// module chunks = 0